export default "__VITE_ASSET__BdgZru5l__"